export default __webpack_public_path__ + "static/media/fontawesome-webfont.f0af1680.ttf";